import { Box, Typography } from "@mui/material";

interface InfoSectionProps {
  title: string;
  content: string;
  sx?: object;
}

const InfoSection = ({ title, content, sx }: InfoSectionProps) => (
  <Box 
    sx={{
      ...sx,
      bgcolor: "#ffffff",
      borderRadius: "16px",
      padding: "20px 24px",
      border: "1px solid #e5e7eb",
      transition: "all 0.2s ease",
      "&:hover": {
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        borderColor: "#d1d5db",
      }
    }}
  >
    <Typography 
      fontWeight="600" 
      sx={{ 
        color: "#E87722", 
        fontSize: "13px",
        letterSpacing: "0.5px",
        textTransform: "uppercase",
        mb: 1.5
      }}
    >
      {title}
    </Typography>
    <Typography 
      sx={{ 
        color: "#111827", 
        fontSize: "15px",
        lineHeight: 1.8,
        fontWeight: 400
      }}
    >
      {content}
    </Typography>
  </Box>
);

export default InfoSection;
